export const VITE_CLOUDINARY_API_URL = import.meta.env.VITE_CLOUDINARY_API_URL
export const VITE_CLOUDINARY_UPLOAD_PRESET = import.meta.env
  .VITE_CLOUDINARY_UPLOAD_PRESET
export const VITE_CLOUDINARY_API_KEY = import.meta.env.VITE_CLOUDINARY_API_KEY
export const VITE_CLOUDINARY_SECRET_KEY = import.meta.env
  .VITE_CLOUDINARY_SECRET_KEY
